// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--NTzwM";
export var nav = "styles-module--nav--geW2n";
export var navItem = "styles-module--nav-item--TKIHL";
export var sectionName = "styles-module--section-name--5t93P";
export var link = "styles-module--link--VhurE";
export var title = "styles-module--title--etNLG";
export var arrowIcon = "styles-module--arrow-icon--dBkbp";